import { useQuery } from '@tanstack/react-query';
import { endUsersApi } from '../api/end-users.api';
import type { EndUsersListParams, EndUsersPagedResult } from '../types/end-users.types';
import { endUserKeys } from './queryKeys';

export const useEndUsers = (params: EndUsersListParams = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: endUserKeys.list(params),
    queryFn: async (): Promise<EndUsersPagedResult> => {
      const response = await endUsersApi.listEndUsers(params);
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    endUsers: data?.items ?? [],
    pagination: {
      page: data?.page ?? 1,
      pageSize: data?.pageSize ?? 10,
      totalCount: data?.totalCount ?? 0,
      totalPages: data?.totalPages ?? 0,
      hasPreviousPage: data?.hasPreviousPage ?? false,
      hasNextPage: data?.hasNextPage ?? false,
      firstItemOnPage: data?.firstItemOnPage,
      lastItemOnPage: data?.lastItemOnPage,
    },
    isLoading,
  };
};
